// extracted by mini-css-extract-plugin
export var contactList = "contactList-module--contactList--8ksSV";
export var item = "contactList-module--item--mh8wz";